import React from 'react';
import './RegistroForm.css';

const RegistroModal = ({ isOpen, onClose }) => {
  if (!isOpen) return null;

  const handleSubmit = event => {
    event.preventDefault();
    onClose(); // Cierra el modal esto es para la primera fase
  };

  return (
    <div className="registro-modal-overlay">
      <div className="registro-modal">
        <button className="registro-close-button" onClick={onClose}>
          ×
        </button>
        <div className="registro-card">
          <h2 className="registro-title">Registrate</h2>
          <form className="registro-form" onSubmit={handleSubmit}>
            <input
              type="text"
              placeholder="Nombre:"
              className="registro-input"
            />
            <input
              type="text"
              placeholder="Apellido:"
              className="registro-input"
            />
            <input
              type="email"
              placeholder="Correo electronico:"
              className="registro-input"
            />
            <input
              type="tel"
              placeholder="Numero telefonico:"
              className="registro-input"
            />
            <button type="submit" className="registro-button">
              Registrarse
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default RegistroModal;
